<template>
	<div class="container">
	<div id="new-version">
		<img class="svg partner-logo" :src="imgLogo" :alt="imgAlt" />
		<p id="new-version-heading" class="standard-heading">
			{{ $t('weveUpdated') }}
		</p>
		<p class="standard-text">
			{{ $t('toGetLatestVersion') }}</p>

		<div id="new-version-buttons">
			<button @click="handleRefreshClick" class="standard-button primary">
				{{ $t('refresh') }}
			</button>
		</div>
	</div>
	</div>
</template>

<script>
export default {
	name: 'NewVersion',
	props: [],
	data: function() {
		return ar.state;
	},
	methods: {
		handleRefreshClick: function(evt) {
			window.location.href = '/';
		}
	},
	computed: {
		imgLogo: function () {
			return ar.partnerLogoUrl(this.partner);
		},
		imgAlt: function () {
			return ar.partnerLogoAltText(this.partner);
		}
	}
};
</script>

<style scoped>
.container {
    display: flex;
    align-items: center;
    justify-content: center;
}

#new-version {
	height: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 80%;
	max-width: 80%;
	height: 100%;
	margin-top: 2rem;

	p {
		margin-top: 2rem;

		&#new-version-heading {
			padding-left: 10%;
			padding-right: 10%;
		}
	}
}

#new-version-buttons {
	margin-top: 4rem;
	display: inline-flex;
	flex-wrap: wrap;
	justify-content: center;
	margin-left: auto;
	margin-right: auto;
	max-width: 80%;
	row-gap: 1rem;
}
</style>
